import { check } from "../icons.ts";
import type { WidgetConfig } from "../lib/types.ts";
import { Avatar } from "./Header.tsx";
import { Icon } from "./Icon.tsx";
import styles from "./Consent.module.css";

/** Terms the tenant wants accepted before the first question (settings.widget.consent). */
export function Consent({ config, onAccept }: { config: WidgetConfig; onAccept(): void }) {
  const consent = config.widget.consent ?? {};
  return (
    <div class={styles.consent}>
      <div class={styles.scroll}>
        <Avatar config={config} size="lg" />
        <h2 class={styles.title}>Zanim zaczniemy</h2>
        {consent.intro && <p class={styles.intro}>{consent.intro}</p>}
        {!!consent.summary?.length && (
          <ul class={styles.summary}>
            {consent.summary.map((item) => (
              <li key={item}>
                <Icon svg={check} class={styles.check} />
                {item}
              </li>
            ))}
          </ul>
        )}
        {!!consent.sections?.length && (
          <details class={styles.details}>
            <summary>Pełne warunki korzystania</summary>
            {consent.sections.map((section) => (
              <section key={section.title}>
                <h3>{section.title}</h3>
                <p>{section.text}</p>
              </section>
            ))}
          </details>
        )}
      </div>
      <div class={styles.footer}>
        <button type="button" class={styles.accept} onClick={onAccept}>
          Rozumiem, zaczynamy
        </button>
      </div>
    </div>
  );
}
